import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropPrimaryData, setFootprintingCropPrimaryDataAdmin } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_CROP_PRIMARY_DATA } from "consts";

import { FootprintingCropPrimaryData } from "models";

export const useMutateFootprintingCropPrimaryData = (
  farmId: string,
  cropId: string,
  year: number,
  payload: Omit<FootprintingCropPrimaryData, "id">,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropPrimaryDataAdmin : setFootprintingCropPrimaryData;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [...footprintingCropPrimaryQueryKeys(primaryDataId ?? "", farmId, cropId, year, isAdmin)]);
      },
    },
    queryClient
  );
};
